import { loadGameplan } from "../common/api";

const model = {
    name: 'gameplan',
    state: { 
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.gpid
            }
        },
        cdcInsert: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.gpid]: { ...payload.cdc }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.gpid]: {
                        ...state.byId[payload.gpid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.gpid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        loadedGameplan: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadGameplan( { aid, uid } ) {
            const list = await loadGameplan( aid, uid );
            let byId = {};
            list.forEach( l => byId[l.gpid] = l );
            dispatch.gameplan.loadedGameplan( byId );
        },
        insert( { gpid, cdc } ) {
            dispatch.gameplan.cdcInsert( { gpid, cdc } );
        },
        modify( { gpid, cdc } ) {
            dispatch.gameplan.cdcModify( { gpid, cdc } );
        },
        remove( { gpid } ) {
            dispatch.gameplan.cdcRemove( { gpid } );
        },
        setCurrent( { gpid } ) {
            dispatch.gameplan.setCurrentId( { gpid } );
        }
    } )
}

export default model;